import * as API_CONSTANT from '../constants'

export const uploadFile = (file, date, type) => 
    fetch(`${API_CONSTANT.fms_v3_fe_path}/file/upload`, {
        method: 'POST',
        headers: API_CONSTANT.upload_headers(file, date, type),
        body: file,
        redirect: "follow"
    })
    .then(res => res.json())

export const uploadFileFuelReceipt = (path, file, time) =>
    fetch(`${API_CONSTANT.fms_v3_fe_path}/file/upload`, {
        method: 'POST',
        headers: {
            'Content-Type': file.type || 'image/jpeg',
            'x-path': path,
            'x-file-name': `${time}.${file?.name.split('.')?.[1] || 'png'}` || 'image.jpg'
        },
        body: file,
        redirect: "follow"
    })
    .then(res => res.json())

export const deleteFile = (path) => 
    fetch(`${API_CONSTANT.fms_v3_fe_path}/file/delete`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            path: path
        }),
        redirect: "follow"
    })
    .then(res => res.json())